import { broker } from 'src/constants/paymentTypes';
import { ANNUAL } from 'src/constants/paymentQuantityOptions';
import { PaymentDataFields } from 'src/store/emissionPolicy/slice/emissionPolicySlice';
import { EmissionPaymentConditions } from '../../../EmissionRequest';
import parsePaymentType from './parsePaymentType';

export default function makePaymentConditions(
  paymentFields: PaymentDataFields,
): EmissionPaymentConditions {
  let usedQuantity = 1;

  /** payDay starts as the current selected paymentDayNumber or the default(current date)  */
  let payDay = parseInt(paymentFields.paymentDayNumber, 10);

  if (paymentFields.paymentQuantityType !== ANNUAL) {
    usedQuantity = paymentFields.paymentQuantity;
  }
  if (paymentFields.type === broker) {
    payDay = 15;
  }

  return {
    paymentMethods: parsePaymentType(paymentFields.type),
    amountPayments: usedQuantity,
    payDay,
    policyStartDate: paymentFields.policyStartDate,
  };
}
